module.exports = __webpack_public_path__ + "img/de.ac4d7801.svg";